import { render, staticRenderFns } from "./AssetLabelDialog.vue?vue&type=template&id=db02433c&scoped=true"
import script from "./AssetLabelDialog.vue?vue&type=script&lang=js"
export * from "./AssetLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db02433c",
  null
  
)

export default component.exports